export enum FreightLoaderId {
  GENERATE_FREIGHT_QUOTE = "GENERATE_FREIGHT_QUOTE",
  FETCH_FREIGHT_QUOTE = "FETCH_FREIGHT_QUOTE",
}
